module.exports = __webpack_public_path__ + "img/HttpsOutlined.7213e2f5.svg";